import { Controller } from "@hotwired/stimulus"

// Mostra o painel de prazos do dia clicado, oculta os outros.
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const dia = event.params.dia
    this.panelTargets.forEach((panel) => {
      const isAlvo = panel.dataset.dia === String(dia)
      panel.hidden = isAlvo ? !panel.hidden : true
    })
  }
}
